import React from "react";
import "./InlineRefreshIndicator.css";

/**
 * A compact, non-blocking refresh indicator.
 * Shows a thin progress bar at the top of the content area when data is being refreshed.
 * Does NOT block the UI — the page content renders underneath.
 *
 * @param {{ isRefreshing: boolean }} props
 */
const InlineRefreshIndicator = ({ isRefreshing }) => {
    if (!isRefreshing) return null;

    return (
        <div className="tp-inline-refresh">
            <div className="tp-inline-refresh__bar" />
        </div>
    );
};

export default InlineRefreshIndicator;
